/**
 * "Marka" brand filter checkboxes on a product category archive —
 * inc/category-archive.php's render_brand_filter(). The checkboxes carry no
 * "name" of their own: WooCommerce's own "filter_product_brand" query var
 * (already read by WC_Brands::update_product_query_tax_query() to filter the
 * main product query) is a single comma-separated list of term IDs, not an
 * array, so every change joins the checked boxes into the hidden input and
 * submits the form.
 */

const form = document.querySelector('[data-brand-filter-form]');
const hiddenValue = form?.querySelector('[data-brand-filter-value]');
const checkboxes = form?.querySelectorAll('[data-brand-filter-checkbox]');

if (form && hiddenValue && checkboxes?.length) {
	checkboxes.forEach((checkbox) => {
		checkbox.addEventListener('change', () => {
			const checked = Array.from(checkboxes)
				.filter((box) => box.checked)
				.map((box) => box.value);

			hiddenValue.value = checked.join(',');
			form.submit();
		});
	});
}
